export type FuelStationReportsNavItem = { resource: string; label: string };

export type FuelStationReportsNavSection = {
    sectionLabel: string;
    items: FuelStationReportsNavItem[];
};

/** Reports destinations (Fueling Station workspace). */
export const FUEL_STATION_REPORTS_NAV_SECTIONS: FuelStationReportsNavSection[] = [
    {
        sectionLabel: 'Operations',
        items: [{ resource: 'pumpSheetReport', label: 'Pump sheet' }],
    },
    {
        sectionLabel: 'Inventory',
        items: [
            { resource: 'itemLedgerReport', label: 'Item Ledger' },
            { resource: 'stockMovementReport', label: 'Stock Movement' },
            { resource: 'itemStockReport', label: 'Item Stock' },
        ],
    },
];
